var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBikeRack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 54,
    viewBox: "0 0 90 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4006 36.2728C32.4006 45.591 25.2352 53.1 16.4503 53.1C7.66534 53.1 0.5 45.591 0.5 36.2728C0.5 26.9546 7.66534 19.4456 16.4503 19.4456C25.2352 19.4456 32.4006 26.9546 32.4006 36.2728Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5001 36.3499C89.5001 45.6681 82.3347 53.1771 73.5498 53.1771C64.7648 53.1771 57.5995 45.6681 57.5995 36.3499C57.5995 27.0317 64.7648 19.5227 73.5498 19.5227C82.3347 19.5227 89.5001 27.0317 89.5001 36.3499Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2852 1.36531C34.2852 1.36531 24.613 0.0465379 23.8288 2.42033C23.0445 4.79412 29.3184 8.22293 29.3184 8.22293L15.4636 36.4447",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7882 4.98041C57.4532 3.94595 59.663 4.72179 59.9085 5.75625C60.154 6.79071 58.1898 10.1527 58.1898 10.1527M48.8293 36.4447H73.9249L58.1898 10.1527M48.8293 36.4447L58.1898 10.1527M48.8293 36.4447L25.0437 17.6525M58.1898 10.1527L27.99 11.1872",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1664 52.7309C26.1663 31.2889 22.9518 19.4389 33.6663 19.4388C44.3807 19.4388 48.1307 19.4388 57.2379 19.4389C66.3451 19.4389 65.2736 26.2107 65.2736 51.6026",
    stroke: "#319300",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBikeRack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bikeRack.0e0e9da283cd4800f4eb89b67de041b1.svg";